import Cover from './cover';
import Img from './img';

Cover.Img = Img;

export default Cover;
